/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 12:45:44
 */

import React from 'react';

// ui-components
import {Banner} from '@shopify/polaris';
import PageSkeleton from '~/pages/common/PageSkeleton';

// client
import ApiClient from '~/client/ApiClient';

// helpers
import {parseAxiosError} from '~/helpers/request';

// environmental
import {getOlcWebsite} from '~/env';

const apiClient = new ApiClient();

interface Props {
}

const ApiErrorHandler: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    (async () => {
      try {
        await apiClient.post('/account/verify');
      } catch (e) {
        setError(parseAxiosError(e));
      } finally {
        setLoading(false);
      }
    })();
  });

  if (loading) {
    return <PageSkeleton/>;
  }

  if (error !== null) {
    return (
      <Banner
        title="An error occurred while processing the request"
        action={{content: 'Contact Support', url: getOlcWebsite()}}
        tone="critical">
        <p>
          <strong>{error}</strong>
        </p>
      </Banner>
    );
  }

  return (
    <>{props.children}</>
  );
};

export default ApiErrorHandler;
